export default [
  {
    header: "Progr. Agrícolas",
    resource: "Pr Fert Programacion",
    action: "menu",
  },
  {
    title: "Fertilización",
    icon: "fa-solid fa-seedling",
    children: [
      {
        title: "Programación",
        route: "prfertprogramacion",
        action: "menu",
        resource: "Pr Fert Programacion",
      },
      {
        title: "Reportes",
        route: 'prfertreporte',
        action: "menu",
        resource: "Pr Ma Fe Area",
      },
      /*
      {
        title: "Tablero de Cruce",
        route: "prferttablero",
        action: "menu",
        resource: "Pr Fert Tablero",
      },
      */
    ],
  },
  {
    title: "Riego",
    icon: "fa-solid fa-faucet-drip",
    children: [
      {
        title: "Programación",
        route: "prriegprogramacion",
        action: "menu",
        resource: "Pr Rieg Programacion",
      },
      {
        title: "Reportes",
        action: "menu",
        resource: "Reportes Riego",
        children:[
          {
            title: "- Resumen General",
            route: "reportesgeneral",
            action: "menu",
            resource: "Reportes Riego",
          },
          {
            title: "- Por Variedad",
            route: "reportesporvariedad",
            action: "menu",
            resource: "Reportes Riego",
          },
          {
            title: "- Detallado",
            route: "reportesdetallado",
            action: "menu",
            resource: "Reportes Riego",
          }
        ]
      },
    ],
  },
  {
    title: "Maquinaria",
    icon: "fa-solid fa-tractor",
    children: [
      {
        title: "Programación",
        route: "prmaquprogramacion",
        action: "menu",
        resource: "Pr Maqu Programacion",
      },
      {
        title: "Tablero de Cruce",
        route: "prmaqutablero",
        action: "menu",
        resource: "Pr Maqu Tablero",
      },
    ],
  },
  {
    title: "Mano de Obra",
    icon: "fa-solid fa-users-line",
    children: [
      {
        title: "Programación",
        route: "prmobrprogramacion",
        action: "menu",
        resource: "Pr MObr Programacion",
      },
      {
        title: "Tablero de Cruce",
        route: "prmobrtablero",
        action: "menu",
        resource: "Pr MObr Tablero",
      },
    ],
  },
  {
    title: "Mantenedores",
    icon: "fa-solid fa-database",
    children: [
      {
        title: "Riego y Fertilización",
        icon: "fa-solid fa-seedling",
        resource: "Pr Ma Fe Area",
        children: [
          // {
          //   title: "Áreas",
          //   route: "prmanareas",
          //   action: "menu",
          //   resource: "Pr Ma Fe Area",
          // },
          // {
          //   title: "Sub-Áreas",
          //   route: "prmansubareas",
          //   action: "menu",
          //   resource: "Pr Ma Fe Area",
          // },
          {
            title: "Usuarios",
            route: "prmanresponsables",
            action: "menu",
            resource: "Pr Ma Fe Area",
          },
          /*
          {
            title: "Implementos",
            route: "prmanimplementos",
            action: "menu",
            resource: "Pr Ma Fe Area",
          },
          */
          {
            title: "Lotes y Válvulas",
            route: "prmanlotes",
            action: "menu",
            resource: "Pr Ma Fe Area",
          },
          // {
          //   title: "Tipos de Programas",
          //   route: "prmantprogramas",
          //   action: "menu",
          //   resource: "Pr Ma Fe Area",
          // },
          {
            title: "Parámetros",
            route: "prmanparametros",
            action: "menu",
            resource: "Pr Ma Fe Area",
          },
          {
            title: "Productos",
            route: "prproductos",
            action: "menu",
            resource: "Pr Ma Fe Area",
          },
        ],
      },
      {
        title: "Maquinaria",
        icon: "fa-solid fa-tractor",
        resource: "Pr Ma Fe Area",
        children: [
          {
            title: "Maquinarias",
            route: "prmaquinarias",
            action: "menu",
            resource: "Pr Ma Fe Area",
          },
          {
            title: "Implementos",
            route: "primplementos",
            action: "menu",
            resource: "Pr Ma Fe Area",
          },
          {
            title: "Actividad y Labor",
            route: "practlab",
            action: "menu",
            resource: "Pr Ma Fe Area",
          },
          {
            title: "Turnos y Cecos",
            route: "prturceco",
            action: "menu",
            resource: "Pr Ma Fe Area",
          },
          {
            title: "Responsables",
            route: "prresponsables",
            action: "menu",
            resource: "Pr Ma Fe Area",
          },
        ],
      },
    ],
  },
];
